import React, { useCallback, useState } from 'react';
import { Button, Checkbox, Content, Flex, Label, Popup, Text } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import StringUtil from '@leverege/string-util';
import { DAYS } from "./Constants.js";
import { getEvenOddVariant } from "./Util.js";
const {
  t,
  tIcon
} = I18N.ns('imagine.operatingHours.CopyHoursWidget');
const DEFAULT_VALUE = DAYS.reduce((prev, curr) => {
  prev[curr] = false;
  return prev;
}, {});
export default function CopyHoursWidget(props) {
  const {
    onChange: pOnChange,
    eventData,
    className,
    isEven
  } = props;
  const [value, setValue] = useState({
    ...DEFAULT_VALUE
  });
  const [opened, setOpened] = useState(false);
  const onChange = useCallback(({
    value: val,
    data
  }) => {
    setValue({
      ...value,
      [data]: val
    });
  }, [setValue, value]);
  const onPopupChange = useCallback(({
    isOpened
  }) => {
    setOpened(isOpened);
  }, []);
  const onSubmit = useCallback(() => {
    pOnChange({
      value,
      data: eventData
    });
    setOpened(false);
    setValue({
      ...DEFAULT_VALUE
    });
  }, [value, eventData, pOnChange]);
  return /*#__PURE__*/React.createElement(Popup, {
    className: className,
    opened: opened,
    onChange: onPopupChange,
    icon: tIcon('copyIcon', 'fa fa-fw fa-clone'),
    toggleVariant: getEvenOddVariant('copyHoursWidget', isEven, 'linkNeutralNoPad')
  }, /*#__PURE__*/React.createElement(Content, {
    variant: "copyHoursWidget|dialog",
    relative: true
  }, /*#__PURE__*/React.createElement(Content.Header, {
    variant: "copyHoursWidgetHeader"
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "caption"
  }, t('copyTo'))), /*#__PURE__*/React.createElement(Content.Area, {
    variant: "copyHoursWidgetContent"
  }, /*#__PURE__*/React.createElement(Flex, {
    variant: "colL"
  }, DAYS.map(day => {
    const dayName = StringUtil.capitalize(day);
    const eD = `set${dayName}`;
    const disabled = eventData === eD;
    return /*#__PURE__*/React.createElement(Flex, {
      key: dayName,
      variant: "rowSpaceBetween"
    }, /*#__PURE__*/React.createElement(Label, {
      variant: "captionSmallBold"
    }, dayName), /*#__PURE__*/React.createElement(Checkbox, {
      value: disabled || value[day],
      disabled: disabled,
      onChange: onChange,
      eventData: day
    }));
  }))), /*#__PURE__*/React.createElement(Content.Footer, {
    variant: "copyHoursWidgetFooter",
    layout: "flex:rowSpaceAround"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "copyHoursSubmit|secondary",
    onClick: onSubmit
  }, t('apply')))));
}